const columns = [
  {
    title: '终端号',
    key: 'term_no',
    width: 200,
  },
  {
    title: '接入类型',
    key: 'channel_code_name',
    width: 300,
  },
  {
    title: '用户名',
    key: 'user_id',
    width: 300,
  },
  {
    title: '用户姓名',
    key: 'user_cn_name',
    width: 300,
  },
  {
    title: '所属部门',
    key: 'dept_cn_name',
  },
  {
    title: '启用状态',
    key: 'use_state',
    width: 200,
    render:(h,{columns,row,index}) =>{
      let target_host = '';
      switch(row.use_state){
        case 1:
          target_host = '待启用';
          break;
        case 2:
          target_host = '已启用';
          break;
        default:
          target_host = '--'
      }
      return h("span",target_host);
    }
  }
]

export default columns